import { render, staticRenderFns } from "./PerformanceReview.vue?vue&type=template&id=132c846b&scoped=true"
import script from "./PerformanceReview.vue?vue&type=script&lang=js"
export * from "./PerformanceReview.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReview.vue?vue&type=style&index=0&id=132c846b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c846b",
  null
  
)

export default component.exports